import { industryNews } from "@/mocks/homeNews";
import { MetaRow, SectionHead, Tag } from "./bits";

export default function IndustrySection() {
  return (
    <section id="secret" className="bg-background-100/70 border-y border-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-14">
        <SectionHead
          eyebrow="深度内幕"
          title="行业秘密：后台比台前更值得看"
          desc="片酬、报价、番位、档期——那些台面上不讲的规则，我们一条条帮你拆开看。"
        />
        <div className="flex flex-col gap-5">
          {industryNews.map((s, i) => (
            <article
              key={s.id}
              className="group grid grid-cols-1 md:grid-cols-12 gap-5 items-center rounded-lg border border-background-200 bg-background-50 p-4 md:p-5 transition-colors hover:border-primary-300 cursor-pointer"
            >
              <div className="md:col-span-3 relative overflow-hidden rounded-md aspect-[16/9] md:aspect-auto md:h-44">
                <img
                  src={s.image}
                  alt={s.title}
                  title={`${s.title} | 行业秘密`}
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="md:col-span-6">
                <div className="flex items-center gap-2 mb-2">
                  <Tag label={s.tag} tone={s.tagTone || "secondary"} />
                  <span className="inline-flex items-center gap-1 text-xs text-foreground-600 whitespace-nowrap">
                    <i className="ri-lock-2-line w-4 h-4 flex items-center justify-center text-primary-500" />
                    后台独家渠道
                  </span>
                </div>
                <h3 className="text-base md:text-lg font-bold text-foreground-950 leading-snug group-hover:text-primary-700 transition-colors">
                  {s.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">{s.summary}</p>
              </div>
              <div className="md:col-span-3 flex md:flex-col items-center md:items-end justify-between gap-3 border-t md:border-t-0 md:border-l border-background-200 md:pl-5 pt-3 md:pt-0">
                <span className="font-heading text-5xl md:text-6xl font-black leading-none text-secondary-200 group-hover:text-primary-400 transition-colors">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <MetaRow time={s.time} reads={s.reads} />
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}